var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85175 7.83046C9.01407 7.83046 10.767 6.07755 10.767 3.91523C10.767 1.75291 9.01407 0 6.85175 0C4.68943 0 2.93652 1.75291 2.93652 3.91523C2.93652 6.07755 4.68943 7.83046 6.85175 7.83046Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85165 18.5983C10.6357 18.5983 13.7033 16.8454 13.7033 14.6831C13.7033 12.5207 10.6357 10.7678 6.85165 10.7678C3.06759 10.7678 0 12.5207 0 14.6831C0 16.8454 3.06759 18.5983 6.85165 18.5983Z",
    fill: "#FFD600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5963 14.6821C18.5963 16.3039 16.6035 17.6185 14.1712 17.6185C14.8876 16.8354 15.381 15.8517 15.381 14.684C15.381 13.5143 14.8867 12.5306 14.1682 11.7466C16.6015 11.7456 18.5963 13.0612 18.5963 14.6821ZM15.6599 3.91519C15.6602 4.38767 15.5465 4.85326 15.3285 5.27241C15.1104 5.69156 14.7944 6.0519 14.4073 6.32283C14.0202 6.59377 13.5735 6.76729 13.105 6.82867C12.6365 6.89006 12.1601 6.83749 11.7163 6.67542C12.1945 5.83418 12.4451 4.88283 12.4436 3.91519C12.4436 2.91191 12.1793 1.9703 11.7173 1.15593C12.1611 0.994065 12.6373 0.941648 13.1057 1.00313C13.574 1.0646 14.0206 1.23816 14.4076 1.50907C14.7945 1.77998 15.1104 2.14025 15.3285 2.5593C15.5465 2.97834 15.6602 3.44282 15.6599 3.91519Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchants);
export default __webpack_public_path__ + "static/media/merchants.1b82757077eb1010aa0d9a1bdda5c99e.svg";
export { ForwardRef as ReactComponent };